export default __webpack_public_path__ + "fbf726f3b90b19e9bab17d5c507ebdaa.svg";